import { User } from './user';

export class Message {
    private id: String;
    private message: String;
    private deliveredAt: Number;
    private author: User;

    constructor(id: String) {
        this.id = id;
    }

    public setId(id: String) { this.id = id; }
    public getId() { return this.id; }
    public setMessage(message: String) { this.message = message; }
    public getMessage() { return this.message; }
    public setDeliveredAt(delivered: Number) { this.deliveredAt = delivered; }
    public getDeliveredAt() { return this.deliveredAt; }
    public getDeliveredTime() {
        const date = new Date((this.deliveredAt.valueOf() * 1000));
        let time = (date.getDate() <= 9) ? '0' + date.getDate() : date.getDate();
        time += '.' + (((date.getMonth() + 1) <= 9) ? '0' + date.getMonth() : date.getMonth());
        time += '.' + date.getFullYear();
        time += ' - ' + ((date.getHours() <= 9) ? '0' + date.getHours() : date.getHours());
        time += ':' + ((date.getMinutes() <= 9) ? '0' + date.getMinutes() : date.getMinutes()) + ' Uhr';
        return time;
    }
    public setAuthor(author: User) { this.author = author; }
    public getAuthor() { return this.author; }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/models/messages.ts